// Library Methods
import { useMemo } from "react";

// Components
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";

type ExamCardButtonType = {
  updateValue: () => void;
  label: string | JSX.Element;
  isSelected: boolean;
  isDisabled?: boolean;
  color?: string;
};

const ExamCardButton = ({
  updateValue,
  label,
  isSelected,
  isDisabled,
  color,
}: ExamCardButtonType) => {
  const colorToUse = useMemo(() => color ?? "#E2772E", [color]);

  return (
    <Button
      sx={{
        backgroundColor: isSelected ? colorToUse : "#5B6D7A80",
        color: "#FFF",
        fontSize: "12px",
        fontWeight: 500,
        borderRadius: "4px",
        padding: "4px 2px",
        width: "100%",
        minWidth: 0,

        "&:hover": {
          backgroundColor: isSelected ? colorToUse : "#475966",
        },

        "&.Mui-disabled": {
          color: "#FFF",
          backgroundColor: "#435B6D7A",
        },
      }}
      onClick={updateValue}
      disabled={isDisabled}
    >
      <Box
        component="span"
        sx={{
          display: "block",
          width: "100%",
          overflow: "hidden",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
        }}
      >
        {label}
      </Box>
    </Button>
  );
};

export default ExamCardButton;
